import { useEffect, useState } from "react";
import greetingMale from "@/assets/imgs/male-greeting.png";
import greetingFemale from "@/assets/imgs/female-greeting.png";
import { useAuth } from "@/context/auth-context";
import { getFileUrl } from "@/lib/pocketbase";

type GreetingProps = {
  name: string;
  readingPower?: number;
  gender?: "male" | "female";
  avatar?: string;
  userId?: string;
};

const Greeting = ({ name, readingPower }: GreetingProps) => {
  const { user } = useAuth();
  const [imgSrc, setImgSrc] = useState<string | null>(null);
  const isBoy = true;

  useEffect(() => {
    if (user?.avatar) {
      setImgSrc(getFileUrl("users", user.id, user.avatar));
    } else {
      setImgSrc(isBoy ? greetingMale : greetingFemale);
    }
  }, [isBoy, user?.avatar, user?.id]);

  return (
    <section className="dashboard-greeting flex flex-col-reverse lg:flex-row items-center">
      <div className="flex flex-col">
        <h2 className="font-bold capitalize">Hello, {name}!</h2>{" "}
        <span className="greeting-reading-power flex items-center">
          <span>
            Reading Power: {readingPower?.toFixed(0) ?? "0"}
          </span>
          {readingPower === 0 && (
            <span className="text-xs ml-2 opacity-70">
              (Need 5 articles and 2 books)
            </span>
          )}
        </span>
      </div>
      {imgSrc ? (
        <img
          src={imgSrc}
          alt="Illustration of a kid saying hello"
          width={user?.avatar ? 600 : 420}
          height={user?.avatar ? 600 : 420}
          className={`greeting-illustration ${!isBoy && "greeting-female-char"}`}
        />
      ) : (
        ""
      )}
    </section>
  );
};

export default Greeting;
